module.exports = __webpack_public_path__ + "static/media/table.a9e90491.svg";